/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExpressOutboundVo } from './ExpressOutboundVo';
import {
    ExpressOutboundVoFromJSON,
    ExpressOutboundVoFromJSONTyped,
    ExpressOutboundVoToJSON,
    ExpressOutboundVoToJSONTyped,
} from './ExpressOutboundVo';

/**
 * 
 * @export
 * @interface ResponseExpressOutboundVo
 */
export interface ResponseExpressOutboundVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseExpressOutboundVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseExpressOutboundVo
     */
    message?: string;
    /**
     * 
     * @type {ExpressOutboundVo}
     * @memberof ResponseExpressOutboundVo
     */
    data?: ExpressOutboundVo;
}

/**
 * Check if a given object implements the ResponseExpressOutboundVo interface.
 */
export function instanceOfResponseExpressOutboundVo(value: object): value is ResponseExpressOutboundVo {
    return true;
}

export function ResponseExpressOutboundVoFromJSON(json: any): ResponseExpressOutboundVo {
    return ResponseExpressOutboundVoFromJSONTyped(json, false);
}

export function ResponseExpressOutboundVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseExpressOutboundVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExpressOutboundVoFromJSON(json['data']),
    };
}

export function ResponseExpressOutboundVoToJSON(json: any): ResponseExpressOutboundVo {
    return ResponseExpressOutboundVoToJSONTyped(json, false);
}

export function ResponseExpressOutboundVoToJSONTyped(value?: ResponseExpressOutboundVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ExpressOutboundVoToJSON(value['data']),
    };
}

